import { adminConstants } from "../constant/admin-constant";

const initialState = {
    loading: false,
    errorsData: [],
};
export function dataSyncReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.GET_SYNC_ERRORS_LIST_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_SYNC_ERRORS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.errors.current_page,
                pages: action.payload.result.errors.last_page,
                errorsData: action.payload.result.errors.data
            };
        case adminConstants.GET_SYNC_ERRORS_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_SYNC_ERRORS_MESSAGES_LIST_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_SYNC_ERRORS_MESSAGES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.messages.current_page,
                pages: action.payload.result.messages.total_pages,
                errorMessagesList: action.payload.result.messages.data
            };
        case adminConstants.GET_SYNC_ERRORS_MESSAGES_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_ERROR_STATES_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_ERROR_STATES_SUCCESS:
            return {
                ...state,
                loading: false,
                errorStates: action.payload.result
            };
        case adminConstants.GET_ERROR_STATES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_ERROR_STATES_FOR_BRAND_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_ERROR_STATES_FOR_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
                brandErrorState: action.payload.result
            };
        case adminConstants.GET_ERROR_STATES_FOR_BRAND_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.MARK_ERROR_FIXED_REQUEST:
            return { ...state, loading: true };
        case adminConstants.MARK_ERROR_FIXED_SUCCESS:
            return {
                ...state,
                loading: false,
                markError: action.payload
            };
        case adminConstants.MARK_ERROR_FIXED_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/DataSync.jsx